import { Navigate, Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useCheckPermissions } from '../../utils/roles/permissionUtils';

interface ProtectedRouteProps {
  code: string;
  actionTypes?: string[]; // Optional, defaults to ['Read', 'Write', 'Edit', 'Delete']
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ code, actionTypes = ['Read', 'Write', 'Edit', 'Delete'] }) => {
  const hasPermission = useCheckPermissions(code, actionTypes, true);
  return hasPermission ? <Outlet /> : <Navigate to="/not-authorized" />;
};

ProtectedRoute.propTypes = {
  code: PropTypes.string.isRequired,
  actionTypes: PropTypes.arrayOf(PropTypes.string.isRequired),
};

ProtectedRoute.defaultProps = {
  actionTypes: ['Read', 'Write', 'Edit', 'Delete'],
};

export default ProtectedRoute;
